   
$(document).ready(function(){
  $('.promotion-close').click(function(){
    $('.shopify-promotion-bar').hide();
  });

  $('.mob_search_cont').click(function(){
    $('.mob-search').toggleClass('search-active');
  });
});

$(window).on('load', function(){
    setTimeout(function() {
      $('.shippingFormDropdownContainer select#wcpShippingOption').attr('required', true);
       $('.shippingFormDropdownContainer button').addClass('ship_btn');
    }, 3000);  
  /*
       $('.shippingFormDropdownContainer button').click(function (e) {
            e.preventDefault();
            alert('Please select Shipping Rates');
             setTimeout(function() {
                 $('select#wcpShippingOption option:first-of-type').remove();
            }, 3000);  
       });
  */
});
/*
$(window).on('load', function(){
  $('.latest-fifty').show();
  $(".latest-fifty .custom_border_product_grid:gt(49)").addClass("hidden"); 
});
  */

 var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

 function onYouTubeIframeAPIReady() {
     document.querySelectorAll('.banner-video-iframe').forEach((item) => {
         new YT.Player(item, {
             events: {
                 'onReady': (event) => {
                     event.target.playVideo();
                     event.target.mute();
                 }
             }
         })
     })
 }

// Nevermind - fixed it!